
import {
    KC_AUTH_LOGIN,
    KC_AUTH_LOGOUT,
    KC_UPDATE_TOKEN,
} from './_types'

export const loginSuccess = (keycloak, profile, token) => {
    return {
        type: KC_AUTH_LOGIN,
        payload: { keycloak, profile, token }
    }
}

export const logoutSuccess = () => {
    return {
        type: KC_AUTH_LOGOUT
    }
}

export const updateTokenSuccess = (keycloak, token) => {
    return {
        type: KC_UPDATE_TOKEN,
        payload: {keycloak, token}
    }
}